import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import LandingPage from './Components/LandingPage';
import { ClipLoader } from 'react-spinners'; // Import the spinner component
import MainPage from './Components/MainPage';
import { ToastContainer } from 'react-toastify';
import Blog from './Components/Blog';
import Article from './Components/Article';
import Logo from './Images/logo.png';

function App() {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="full-page-spinner flex flex-col items-center justify-center min-h-screen bg-gray-900">
        <div className="relative w-24 h-24">
            <img
                src={Logo} // Replace with the actual path to your logo
                alt="Trendhopper Logo"
                className="absolute inset-0 m-auto w-12 h-12"
            />
            <div className="w-full h-full border-4 border-t-purple-500 border-r-transparent border-b-gray-600 border-l-gray-600 rounded-full animate-spin"></div>
        </div>
        <p className="text-white mt-4 text-center">Loading Trendhopper...</p>
    </div>
    );
  }

  return (
    
    <Router>
      <Routes>
        <Route path="/" element={isAuthenticated ? <Navigate to="/onboarding" /> : <LandingPage />} />

        {/* Ensure /onboarding is a valid route */}
        <Route path="/onboarding" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
        <Route path="/calendar" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
        <Route path="/settings" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
        <Route path="/article/:id" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
        <Route path="/articles-table-view" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
                {/* Blog Routes */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Article />} />
        <Route path="/create-article" element={isAuthenticated ? <MainPage /> : <Navigate to="/" />} />
        {/* Redirect logic for /dashboard */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Navigate to="/onboarding" /> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
